module.exports = __webpack_public_path__ + "svg/book.svg";